var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.3 6.1c-.3-.5-.8-.8-1.3-.8s-1.1.3-1.3.8L1.3 24c-.3.3-.3.6-.3 1.1 0 .8.8 1.6 1.6 1.6h26.8c.8 0 1.6-.8 1.6-1.6 0-.3 0-.8-.3-1.1z"
})));
export default SvgIconArrow;